import Vue from 'vue';

export default new Vue();

export const GEOJSON_SAVED = 'geojsonSaved';
